import { render } from "./WCMyAccount.vue?vue&type=template&id=78d985fa&scoped=true"
import script from "./WCMyAccount.vue?vue&type=script&lang=js"
export * from "./WCMyAccount.vue?vue&type=script&lang=js"

import "./WCMyAccount.vue?vue&type=style&index=0&id=78d985fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d985fa"]])

export default __exports__